import { render, staticRenderFns } from "./SidebarFieldsBlock.vue?vue&type=template&id=c07bce60&scoped=true"
import script from "./SidebarFieldsBlock.vue?vue&type=script&lang=ts"
export * from "./SidebarFieldsBlock.vue?vue&type=script&lang=ts"
import style0 from "./SidebarFieldsBlock.vue?vue&type=style&index=0&id=c07bce60&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c07bce60",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c07bce60')) {
      api.createRecord('c07bce60', component.options)
    } else {
      api.reload('c07bce60', component.options)
    }
    module.hot.accept("./SidebarFieldsBlock.vue?vue&type=template&id=c07bce60&scoped=true", function () {
      api.rerender('c07bce60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/browse/sidebar/SidebarFieldsBlock.vue"
export default component.exports